import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/confronto/lexaipro-vs-chatgpt")({
  head: () => seoMeta({
    title: "LexAIPro vs ChatGPT: quale usare per il lavoro legale?",
    description: "Confronto pratico tra LexAIPro e ChatGPT su ricerca legale, citazioni, privacy e conformità per la professione forense.",
    path: "/confronto/lexaipro-vs-chatgpt",
  }),
  component: () => (
    <ContentPage
      eyebrow="Confronto"
      title="LexAIPro vs ChatGPT per il lavoro legale"
      lead="ChatGPT è un chatbot generalista. LexAIPro è uno strumento professionale costruito sul corpus normativo italiano, con citazioni verificabili e garanzie di privacy."
      tldr="Per uso personale e curiosità: ChatGPT. Per la pratica forense, dove serve precisione, citazioni e privacy: LexAIPro."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Confronto",path:"/confronto/lexaipro-vs-chatgpt"},{name:"vs ChatGPT",path:"/confronto/lexaipro-vs-chatgpt"}]}
      sections={[
        { heading: "Differenze chiave", bullets: [
          "Fonti: LexAIPro cita norme e sentenze italiane verificabili. ChatGPT può inventare riferimenti.",
          "Privacy: LexAIPro applica zero retention e non addestra sui tuoi dati. ChatGPT (piano consumer) può usare i prompt per training.",
          "Specializzazione: LexAIPro è ottimizzato per il diritto italiano. ChatGPT è generalista.",
          "Workflow: LexAIPro include pratiche, clienti, calendario, redazione e PDF. ChatGPT è solo chat.",
          "Conformità: LexAIPro è progettato per GDPR e AI Act EU.",
        ] },
        { heading: "Quando ChatGPT può bastare", body: "Per brainstorming generico, traduzioni semplici o spiegazioni divulgative non riservate. Per qualsiasi attività che richiede affidabilità giuridica, no." },
      ]}
      faq={[
        { q: "Posso usare entrambi?", a: "Sì, ma per la pratica legale LexAIPro è progettato per essere lo strumento di lavoro principale." },
      ]}
      cta={{ label: "Prova LexAIPro gratis", to: "/signup" }}
      heroImage={pickContent(15)}
      updated="2026"
    />
  ),
});
